/****
 * 工具类
 */
import api from "@/api";
import qs from 'qs';
const Utils = {
    /**
     * 对象的深度拷贝
     * @param data 需要拷贝的元数据
     * @return {any} 返回拷贝后的新数据
     */
    deepClone(data) {
        const type = this.getType(data);
        let obj;
        if (type === "array") {
            obj = [];
        } else if (type === "object") {
            obj = {};
        } else {
            //不再具有下一层次
            return data;
        }
        if (type === "array") {
            for (let i = 0, len = data.length; i < len; i++) {
                obj.push(this.deepClone(data[i]));
            }
        } else if (type === "object") {
            for (let key in data) {
                obj[key] = this.deepClone(data[key]);
            }
        }
        return obj;
    },

    /**
     * 判断对象类型
     * @param {Object} object
     * @return {String} object type
     */
    getType(object) {
        var toString = Object.prototype.toString;
        var map = {
            "[object Boolean]": "boolean",
            "[object Number]": "number",
            "[object String]": "string",
            "[object Function]": "function",
            "[object Array]": "array",
            "[object Date]": "date",
            "[object RegExp]": "regExp",
            "[object Undefined]": "undefined",
            "[object Null]": "null",
            "[object Object]": "object"
        };
        if (object instanceof Element) {
            return "element";
        }
        return map[toString.call(object)];
    },
    /**
     * 接口数据返回后处理赋值
     * @param {Array} arr 页面所需字段列表
     * @param {Object} obj 接口获得的数据
     * @return {Object} 页面所需的数据
     */
    getRequestData(arr = [], obj = {}) {
        if (arr.length < 1) {
            return obj;
        } else if (JSON.stringify(obj) === "{}") {
            arr.forEach(el => {
                obj[el] = "";
            });
            return obj;
        } else {
            let data = {};
            arr.forEach(el => {
                data[el] = obj[el] + "";
            });
            return data;
        }
    },
    // 返回上一页
    /**
     *
     * @param {路由守卫next回调} next
     * @param {vue} that
     */
    showConfirm(next, that) {
        that.$confirm({
            title: "确定要离开当前页面吗？",
            content: "离开后您将取消本次编辑的全部内容，确定要离开吗？",
            cancelText: "取消",
            okText: "确定",
            centered: true,
            onOk() {
                next();
            },
            onCancel() {
                that.$router.go(1);
            },
            class: "test"
        });
    },
    /**
     * 按照键名排序
     * @param {Object} obj 要排序的数据
     * @return {Object} 页面所需的数据
     */
    sortByKey(obj) {
        // 
        const newkey = Object.keys(obj).sort()
        var newObj = {};//创建一个新的对象，用于存放排好序的键值对
        for (var i = 0; i < newkey.length; i++) {//遍历newkey数组
            newObj[newkey[i]] = obj[newkey[i]];//向新创建的对象中按照排好的顺序依次增加键值对
        }
        return newObj;
   },
   /**
    * 验签数据的处理
    * @param {Object} obj 要排序的数据
    * @return {Object} 页面所需的数据
    */
   doMd5Data (md5data){
        let md5Str = qs.stringify(md5data)
        return md5Str;
   },
   /**
    * 验签数据固定写死的几个值
    * @param {Object} obj 要添加写死值的对象
    * @return {Object} 页面所需的数据
    */
   addSignData (obj){
       let timeStamp = Date.parse(new Date()) / 1000;
       obj.appid = 'sortingcenter1.0';
       obj.timestamp = timeStamp;
       obj.nonce = "test_sortingcenter";
       return obj;
   },
};

export default Utils;
